<template>
  <ExpandableSettingsItem
    ref="expander"
    class="expandable-color-picker"
    :html-id="htmlId"
    :title="title"
    :parent-ids="parentIds"
    default-expand
    forget-state
    no-animation
  >
    <div>
      <div class="legend mt5 mb10">
        {{ title }}
      </div>
      <SColorPicker :value="value" @input="$emit('input', $event)" />
    </div>
  </ExpandableSettingsItem>
</template>

<script>
import ExpandableSettingsItem from '@/components/expandable-settings-item.vue';
import SColorPicker from '@/components/s-color-picker.vue';

export default {
  name: 'ExpandableColorPicker',
  components: {
    ExpandableSettingsItem,
    SColorPicker,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    parentIds: {
      type: Array,
      default: () => [],
    },
    htmlId: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '#ffffff',
    },
  },
  methods: {
    colorPicked(color) {
      this.$emit('input', color);
    },
    itemExpand(asRefresh) {
      this.$refs.expander.itemExpand(asRefresh);
    },
  },
};
</script>
